/* ============================================================
   CAMPUS GEAR — HEADER JS v2
   Fixed predictive search + all interactions
   ============================================================ */
(function () {
  'use strict';

  /* ── HELPERS ── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  function debounce(fn, ms) {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), ms); };
  }

  // function formatMoney(cents) {
  //   if (!cents && cents !== 0) return '';
  //   const amount = (cents / 100).toFixed(2);
  //   return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // }


  function formatMoney(amount) {
  if (!amount && amount !== 0) return '';
  const num = parseFloat(amount);
  if (isNaN(num)) return '';
  return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     1. STICKY HEADER
     ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initSticky() {
    const wrap = $('.cg-header-wrap');
    if (!wrap || !wrap.dataset.sticky) return;
    const section = wrap.parentElement;
    // Only the menu bar stays pinned: desktop nav bar, or the mobile header bar when the nav is hidden.
    const setTop = () => {
      const nav = wrap.querySelector('.cg-nav-bar');
      const bar = nav && nav.offsetHeight ? nav : wrap.querySelector('.cg-mobile-header');
      const offset = bar ? bar.getBoundingClientRect().top - wrap.getBoundingClientRect().top : 0;
      section.style.setProperty('--cg-sticky-top', `-${Math.max(0, Math.round(offset))}px`);
    };
    setTop();
    on(window, 'resize', setTop);
    on(window, 'load', setTop);
    let ticking = false;
    on(window, 'scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          // Hysteresis: the compact header is shorter, so a single threshold could flicker.
          const y = window.scrollY;
          const scrolled = wrap.classList.contains('scrolled');
          wrap.classList.toggle('scrolled', scrolled ? y > 20 : y > 140);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     2. SEARCH OVERLAY
     ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initSearch() {
    const overlay       = $('.cg-search-overlay');
    const input         = $('.cg-search-input');
    const clearBtn      = $('.cg-search-clear');
    const trendingSec   = $('.cg-trending-section');
    const resultsSec    = $('.cg-results-section');
    const resultsGrid   = $('.cg-results-grid');
    const resultsLabel  = $('.cg-results-label');
    const viewAllLink   = $('.cg-results-view-all');
    const spinnerWrap   = $('.cg-search-spinner-wrap');
    const emptyMsg      = $('.cg-search-empty');

    if (!overlay || !input) return;

    /* Open */
    function openOverlay() {
      overlay.classList.add('open');
      document.body.classList.add('cg-no-scroll');
      requestAnimationFrame(() => input.focus());
    }

    /* Close */
    function closeOverlay() {
      overlay.classList.remove('open');
      document.body.classList.remove('cg-no-scroll');
      resetSearch();
    }

    /* Reset to trending state */
    function resetSearch() {
      input.value = '';
      showClear(false);
      showTrending(true);
      showResults(false);
      showSpinner(false);
      showEmpty(false);
      if (resultsGrid) resultsGrid.innerHTML = '';
    }

    /* State helpers */
    function showClear(v)    { clearBtn  && clearBtn.classList.toggle('visible', v); }
    function showTrending(v) { trendingSec && (trendingSec.style.display = v ? '' : 'none'); }
    function showResults(v)  { resultsSec && resultsSec.classList.toggle('show', v); }
    function showSpinner(v)  { spinnerWrap && spinnerWrap.classList.toggle('show', v); }
    function showEmpty(v)    { emptyMsg && emptyMsg.classList.toggle('show', v); }

    /* Trigger open — all [data-cg-search-open] */
    $$('[data-cg-search-open]').forEach(btn => {
      on(btn, 'click', e => { e.preventDefault(); openOverlay(); });
    });

    /* Close button */
    $$('[data-cg-search-close]').forEach(btn => {
      on(btn, 'click', closeOverlay);
    });

    /* Backdrop click */
    const backdrop = $('.cg-search-backdrop');
    on(backdrop, 'click', closeOverlay);

    /* Escape key */
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('open')) closeOverlay();
    });

    /* Clear button */
    on(clearBtn, 'click', () => {
      input.value = '';
      input.focus();
      showClear(false);
      showTrending(true);
      showResults(false);
      showSpinner(false);
      showEmpty(false);
      if (resultsGrid) resultsGrid.innerHTML = '';
    });

    /* Trending tag clicks */
    $$('.cg-trending-tag').forEach(tag => {
      on(tag, 'click', e => {
        e.preventDefault();
        const q = tag.dataset.query || tag.textContent.trim();
        input.value = q;
        showClear(true);
        doSearch(q);
      });
    });

    /* ── PREDICTIVE SEARCH ── */
    const doSearch = debounce(async (q) => {
      const query = q.trim();

      if (!query || query.length < 2) {
        showTrending(true);
        showResults(false);
        showSpinner(false);
        showEmpty(false);
        return;
      }

      showTrending(false);
      showResults(false);
      showSpinner(true);
      showEmpty(false);

      try {
        // Shopify predictive search API
        // const params = new URLSearchParams({
        //   q: query,
        //   'resources[type]': 'product',
        //   'resources[limit]': '8',
        //   'resources[options][fields]': 'title,product_type,variants.title,vendor',
        //   'resources[options][unavailable_products]': 'last'
        // });


        const params = new URLSearchParams({
  q: query,
  'resources[type]': 'product',
  'resources[limit]': '10',
  'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor',
  'resources[options][unavailable_products]': 'last'
});

        const response = await fetch(`/search/suggest.json?${params}`, {
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const products = data?.resources?.results?.products || [];

        showSpinner(false);

        if (!products.length) {
          showEmpty(true);
          showResults(false);
          return;
        }

        /* Render results */
        renderProducts(products, query);

      } catch (err) {
        console.error('[CG Search]', err);
        showSpinner(false);
        showEmpty(true);
      }
    }, 300);

    function renderProducts(products, query) {
      if (!resultsGrid) return;

      // Label
      if (resultsLabel) {
        resultsLabel.textContent = `${products.length} result${products.length !== 1 ? 's' : ''} for "${query}"`;
      }

      // View all link
      if (viewAllLink) {
        viewAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
      }

      // Cards
      resultsGrid.innerHTML = products.map(product => {
        const price = product.price ? formatMoney(product.price) : '';
        const imgSrc = product.image || product.featured_image || '';
        const title = product.title || '';
        const url = product.url || `/products/${product.handle}`;

        return `
          <a href="${escapeHtml(url)}" class="cg-result-card">
            <div class="cg-result-img">
              ${imgSrc
                ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(title)}" loading="lazy" width="300" height="300">`
                : '<div style="width:100%;height:100%;background:#eee;border-radius:8px;"></div>'
              }
            </div>
            <p class="cg-result-title">${escapeHtml(title)}</p>
            ${price ? `<p class="cg-result-price">${escapeHtml(price)}</p>` : ''}
          </a>
        `;
      }).join('');

      showResults(true);
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /* Input listener */
    on(input, 'input', () => {
      const q = input.value;
      showClear(q.length > 0);
      if (!q.trim()) {
        showTrending(true);
        showResults(false);
        showSpinner(false);
        showEmpty(false);
        if (resultsGrid) resultsGrid.innerHTML = '';
        return;
      }
      doSearch(q);
    });

    /* Enter → full search page */
    on(input, 'keydown', e => {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = `/search?type=product&q=${encodeURIComponent(input.value.trim())}`;
      }
    });
  }

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     3. MOBILE DRAWER
     ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initDrawer() {
    const overlay = $('.cg-drawer-overlay');
    const drawer  = $('.cg-drawer');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      overlay && overlay.classList.add('open');
      document.body.classList.add('cg-no-scroll');
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      overlay && overlay.classList.remove('open');
      document.body.classList.remove('cg-no-scroll');
    }

    $$('[data-cg-drawer-open]').forEach(btn => on(btn, 'click', openDrawer));
    $$('[data-cg-drawer-close]').forEach(btn => on(btn, 'click', closeDrawer));
    on(overlay, 'click', closeDrawer);
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    /* Drawer search → go to results page */
    const drawerInput = $('.cg-drawer-search-input');
    on(drawerInput, 'keydown', e => {
      if (e.key === 'Enter' && drawerInput.value.trim()) {
        window.location.href = `/search?type=product&q=${encodeURIComponent(drawerInput.value.trim())}`;
      }
    });
  }

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     4. NAV SCROLL ARROWS
     ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initNavArrows() {
    const nav  = $('.cg-nav-inner');
    const prev = $('.cg-nav-arrow-prev');
    const next = $('.cg-nav-arrow-next');
    if (!nav) return;

    function updateArrows() {
      const atStart = nav.scrollLeft <= 2;
      const atEnd   = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
      prev && prev.classList.toggle('show', !atStart);
      next && next.classList.toggle('show', !atEnd);
    }

    on(prev, 'click', () => nav.scrollBy({ left: -220, behavior: 'smooth' }));
    on(next, 'click', () => nav.scrollBy({ left:  220, behavior: 'smooth' }));
    on(nav, 'scroll', updateArrows, { passive: true });

    const ro = new ResizeObserver(updateArrows);
    ro.observe(nav);
    updateArrows();
  }

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     5. CART BUBBLE
     ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initCartBubble() {
    function updateAll(count) {
      $$('.cg-cart-count').forEach(el => {
        el.textContent = count;
        el.dataset.count = count;
      });
    }

    // Dawn / custom cart events
    on(document, 'cart:updated',  e => updateAll(e?.detail?.cart?.item_count ?? 0));
    on(document, 'cart-update',   e => updateAll(e?.detail?.cart?.item_count ?? 0));

    // Initial load
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => updateAll(c.item_count || 0))
      .catch(() => {});
  }

  /* ── BOOT ── */
  function boot() {
    initSticky();
    initSearch();
    initDrawer();
    initNavArrows();
    initCartBubble();
  }

  document.readyState === 'loading'
    ? on(document, 'DOMContentLoaded', boot)
    : boot();

})();
